import { breakpoints } from "./breakpoint-constants";
var BodyScrollLock = /** @class */ (function () {
    function BodyScrollLock() {
    }
    BodyScrollLock.toggleBodyScrollPosition = function () {
        var bodyScrollLockClassName = 'u-no-body-scroll';
        if (!document.body.classList.contains(bodyScrollLockClassName)) {
            if (breakpoints().breakpoints.mobile) {
                BodyScrollLock.setBodyScrollElement();
                BodyScrollLock.bodyScrollPosition = document.body.scrollTop || document.documentElement.scrollTop;
            }
            document.body.classList.add(bodyScrollLockClassName);
        }
        else {
            document.body.classList.remove(bodyScrollLockClassName);
            if (breakpoints().breakpoints.mobile) {
                if (BodyScrollLock.bodyScrollElement === 'body') {
                    document.body.scrollTop = BodyScrollLock.bodyScrollPosition;
                }
                else {
                    document.documentElement.scrollTop = BodyScrollLock.bodyScrollPosition;
                }
            }
        }
    };
    BodyScrollLock.setBodyScrollElement = function () {
        if (!BodyScrollLock.bodyScrollElement) {
            if (document.body.scrollTop && document.body.scrollTop > 0) {
                BodyScrollLock.bodyScrollElement = 'body';
            }
            else if (document.documentElement.scrollTop && document.documentElement.scrollTop > 0) {
                BodyScrollLock.bodyScrollElement = 'documentElement';
            }
        }
    };
    BodyScrollLock.bodyScrollPosition = 0;
    BodyScrollLock.bodyScrollElement = '';
    return BodyScrollLock;
}());
export default BodyScrollLock;
